<h2 mat-dialog-title>Update Report Template</h2>
<mat-dialog-content class="template-update__content" [formGroup]="form">
	<mat-form-field appearance="fill" class="full-width">
		<mat-label>Template</mat-label>
		<mat-select formControlName="templateId" [disabled]="loading() || saving()">
			@for (template of templates(); track template.id) {
				<mat-option [value]="template.id">
					{{ template.category?.description }} (ID: {{ template.id }}) (Type:
					{{ typeOfCareName(template.validForTypeOfCareId) }})
				</mat-option>
			}
		</mat-select>
	</mat-form-field>

	<mat-form-field appearance="fill" class="full-width">
		<mat-label>Template HTML</mat-label>
		<textarea matInput rows="10" formControlName="html" [disabled]="saving()"></textarea>
	</mat-form-field>
</mat-dialog-content>
<mat-dialog-actions align="end">
	<button mat-button type="button" class="lvr-secondary" (click)="cancel()" [disabled]="saving()">Cancel</button>
	<button mat-button color="primary" (click)="save()" [disabled]="saving() || form.invalid">Save</button>
</mat-dialog-actions>
